import { QUESTIONNAIRE_STATUS } from '../../../../constants';
import {
  FORTA_BLUE,
  FORTA_ERROR,
  FORTA_GRAY7,
  FORTA_ORANGE,
  FORTA_SUCCESS,
  FORTA_WHITE,
} from '../../../../utils/colors';

export const ACTIVITY_STATUS_COLOR = {
  [QUESTIONNAIRE_STATUS.STARTED]: FORTA_ERROR,
  [QUESTIONNAIRE_STATUS.IN_PROGRESS]: FORTA_ORANGE,
  [QUESTIONNAIRE_STATUS.COMPLETED]: FORTA_SUCCESS,
} as const;

export const ACTIVITY_ROW_SX = {
  display: 'flex',
  gap: '10px',
  overflowX: 'auto',
  pb: '12px',
  '&::-webkit-scrollbar': {
    height: 8,
  },
  '&::-webkit-scrollbar-track': {
    borderRadius: '8px',
    backgroundColor: FORTA_BLUE.light3,
    boxShadow: 'none',
  },
  '&::-webkit-scrollbar-thumb': {
    border: 'none',
    borderRadius: '8px',
    backgroundColor: FORTA_BLUE.primary,
  },
};

export const ACTIVITY_CARD_SX = {
  display: 'flex',
  flexDirection: 'column',
  flex: '0 0 320px',
  p: '10px',
  borderRadius: '12px',
  textAlign: 'left',
  backgroundColor: FORTA_WHITE,
  cursor: 'pointer',
  overflow: 'hidden',
  '&:hover': {
    boxShadow: '1px 2px 4px rgba(0, 0, 0, 0.2)',
  },
};

export const ACTIVITY_CARD_HEADER_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

export const ACTIVITY_CARD_BODY_SX = {
  display: 'flex',
  gap: '10px',
  alignItems: 'flex-end',
};

export const ACTIVITY_CARD_STARTED_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  p: '10px',
};

export const ACTIVITY_CARD_STARTED_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  pl: '20px',
  color: FORTA_GRAY7,
};

export const ACTIVITY_STAGE_METER_SX = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexShrink: 0,
  ml: 'auto',
};

export const ACTIVITY_STAGE_ARC_SX = {
  width: 80,
  height: 80,
  // The arc is the top half of a full pie, so pull up the empty bottom half.
  mb: '-40px',
};
